import Box from "@mui/material/Box";

import { useI18n } from "@/i18n/I18nProvider";

import ServiceTile from "../ServiceTile";
import MenuCard from "./MenuCard";

export default function InsuranceMenu({ onNavigate }) {
  const { t } = useI18n();

  return (
    <MenuCard width="250px">
      <Box
        sx={{
          p: 2,
          pb: 0,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {t.secondary_nav.insurance_services_dropdown.map(
          ({ title, img, url }) => (
            <ServiceTile
              key={url || title}
              url={url}
              title={title}
              img={img}
              onNavigate={onNavigate}
            />
          ),
        )}
      </Box>
    </MenuCard>
  );
}
